import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as supplierActions from './../../../../../actions/supplierAction';
import { uploadAction } from './../../../../../actions/uploadAction';
import SupplierDetail from './SupplierDetail';
import actions from "../../../../../actions";

const mapStateToProps = state => {
    return {
        supplierState: state.supplierReducer,
        uploadState: state.uploadReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSupplierDetail: (id) => dispatch(supplierActions.getSupplierDetail(id)),
        getSupplierDetailAddFAQs: (id) => dispatch(supplierActions.getSupplierDetailAddFAQs(id)),
        setSupplierDetail: (supplier) => dispatch(supplierActions.setSupplierDetail(supplier)),
        updateSupplier: (supplier, callbacks) => dispatch(supplierActions.updateSupplierAction(supplier, callbacks)),
        createSupplier: (supplier, callbacks) => dispatch(supplierActions.createSupplierAction(supplier, callbacks)),
        createSupplierAddFAQs: (supplierFAQs, callBacks) => dispatch(supplierActions.createSupplierAddFAQsAction(supplierFAQs, callBacks)),
        onUploadFile: (filters) => dispatch(uploadAction(filters)),
        getAllSupplierProduct: () => dispatch(supplierActions.getAllSupplierProduct()),
        updateSupplierProduct: (supplierProduct) => dispatch(supplierActions.updateSupplierProductAction(supplierProduct)),
        createSupplierProduct: (supplierProduct) => dispatch(supplierActions.createSupplierProductAction(supplierProduct)),
        deleteSupplierProduct: (supplierProduct) => dispatch(supplierActions.deleteSupplierProductAction(supplierProduct)),
        deleteSupplierFAQs: (id, supplierId) => dispatch(supplierActions.deleteSupplierAddFAQsAction(id, supplierId)),
        getVinWonderSites: () => dispatch(supplierActions.getVinwonderSites()),

        createSupplierTranslate: (supplier) => dispatch(supplierActions.createSupplierTranslate(supplier)),
        updateSupplierTranslate: (supplier) => dispatch(supplierActions.updateSupplierTranslate(supplier)),
        deleteSupplierTranslate: (supplier, refreshParams) => dispatch(supplierActions.deleteSupplierTranslate(supplier, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SupplierDetail));
